import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pt-[12px] md:pt-[14px] sm:flex sm:items-center justify-between" }
const _hoisted_2 = { class: "mb-0 text-sm" }
const _hoisted_3 = {
  key: 0,
  class: "mt-[10px] sm:mt-0"
}
const _hoisted_4 = { class: "inline-block mx-[3px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "inline-block mx-[3px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0"
}
const _hoisted_7 = {
  key: 1,
  class: "inline-block mx-[3px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "inline-block mx-[3px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0" }
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.directT('dashboard.showingResults').replace('{start}', _ctx.startItem).replace('{end}', _ctx.endItem).replace('{total}', _ctx.total)), 1),
    (_ctx.totalPages > 1)
      ? (_openBlock(), _createElementBlock("ol", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToPrevPage && _ctx.goToPrevPage(...args))),
              disabled: _ctx.currentPage <= 1,
              class: _normalizeClass([
            'w-[31px] h-[31px] block leading-[29px] relative text-center rounded-md border transition-all',
            _ctx.currentPage <= 1 
              ? 'border-gray-200 text-gray-400 cursor-not-allowed dark:border-[#2b3a5e] dark:text-gray-600' 
              : 'border-gray-100 dark:border-[#172036] hover:bg-primary-500 hover:text-white hover:border-primary-500'
          ])
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("span", { class: "opacity-0" }, " 0 ", -1),
              _createElementVNode("i", { class: "material-symbols-outlined left-0 right-0 absolute top-1/2 -translate-y-1/2" }, " chevron_left ", -1)
            ]), 10, _hoisted_5)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedPages, (page) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: page }, [
              (page === '...')
                ? (_openBlock(), _createElementBlock("li", _hoisted_6, _cache[3] || (_cache[3] = [
                    _createElementVNode("span", { class: "w-[31px] h-[31px] block leading-[29px] relative text-center" }, "...", -1)
                  ])))
                : (_openBlock(), _createElementBlock("li", _hoisted_7, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.goToPage(Number(page))),
                      class: _normalizeClass([
              'w-[31px] h-[31px] block leading-[29px] relative text-center rounded-md border',
              _ctx.currentPage === Number(page)
                ? 'border-primary-500 bg-primary-500 text-white'
                : 'border-gray-100 dark:border-[#172036] transition-all hover:bg-primary-500 hover:text-white hover:border-primary-500'
            ])
                    }, _toDisplayString(page), 11, _hoisted_8)
                  ]))
            ], 64))
          }), 128)),
          _createElementVNode("li", _hoisted_9, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToNextPage && _ctx.goToNextPage(...args))),
              disabled: _ctx.currentPage >= _ctx.totalPages,
              class: _normalizeClass([
            'w-[31px] h-[31px] block leading-[29px] relative text-center rounded-md border transition-all',
            _ctx.currentPage >= _ctx.totalPages
              ? 'border-gray-200 text-gray-400 cursor-not-allowed dark:border-[#2b3a5e] dark:text-gray-600'
              : 'border-gray-100 dark:border-[#172036] hover:bg-primary-500 hover:text-white hover:border-primary-500'
          ])
            }, _cache[4] || (_cache[4] = [
              _createElementVNode("span", { class: "opacity-0" }, " 0 ", -1),
              _createElementVNode("i", { class: "material-symbols-outlined left-0 right-0 absolute top-1/2 -translate-y-1/2" }, " chevron_right ", -1)
            ]), 10, _hoisted_10)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}